import { Component, ElementRef, OnInit, Renderer2, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-custompage',
  templateUrl: './custompage.page.html',
  styleUrls: ['./custompage.page.scss'],
})
export class CustompagePage {
  pageContent: any;
  content;
  @ViewChild('contentContainer', { static: true }) contentContainer: ElementRef;

  constructor(
    private route: ActivatedRoute,
    private renderer: Renderer2,
    private dataSRV:DataService
  ) { }

  ionViewDidEnter() {
    const pagePath = this.route.snapshot.paramMap.get('customPath');
    this.dataSRV.pageContentArray$.subscribe((pages:any) => {
      if (pages.custom && pages.custom.length > 0) {
        const page = pages.custom.find(p => p.path === pagePath);
        this.content = page ? page.content : 'Content not found';
        this.injectContent();  // Dynamically inject the content
      }
    });
  }

  injectContent() {
    if (this.contentContainer && this.content) {
      this.renderer.setProperty(this.contentContainer.nativeElement, 'innerHTML', this.content);
    }
  }

}
